import { MessagePlugin } from 'tdesign-react';

import { BotDataManagerType, PlazaOrgDataKey } from '@/const/promotion';
import { IBot, IStoryRes } from '@/interface';
import { postMaterial } from '@/utils/material';
import { transformObjectDeep } from '@/utils/tans/object';

import { IPlazaItemInput, IPlazaItemOutput, IPlazaOutput, ItemManage } from './../interface/promotion';
import { apiPathServer } from './api-config';
import { CgiErrorCode, CgiResp } from './cgi';
import { orgBotData, OrgDataType } from './promotionData';
import { API_PREFIX, request } from './request';

/**
 * 拉取整体详情接口
 */
export const fetchPlazaDetail = async (id: string) => {
  const res = await request<CgiResp<IStoryRes>>(`${API_PREFIX}${apiPathServer.plazaDetail}`, {
    query: {
      id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  const turnData = transformObjectDeep(res?.data, 'camel') as IPlazaOutput;
  const data = turnData?.itemList?.map((e) => {
    const temp = orgBotData(OrgDataType.output, e);
    const dataKey = e?.managerType ? PlazaOrgDataKey[e?.managerType as BotDataManagerType] : '';
    return {
      roleSquareId: e?.roleSquareId,
      managerType: e?.managerType,
      style: e?.style,
      id: e?.id,
      bots: temp?.bots,
      space: temp?.space,
      name: (e?.[dataKey as keyof IPlazaItemOutput] as ItemManage)?.name,
    };
  });

  const resultData = {
    name: turnData?.name,
    plazaList: data,
    id,
  };

  return {
    ...res,
    data: resultData,
  };
};

/**
 * 保存整体数据
 * @param plaza
 * @returns
 */
export const modifyPlazaDetail = async (plaza: IPlazaItemInput) => {
  const { ...propData }: any = plaza;
  const postData: IPlazaOutput = {
    id: propData?.id,
    itemList: propData?.plazaList?.map((e: { id: any; }) => ({ id: e?.id })),
    name: propData?.name,
  };
  const res = await request(`${API_PREFIX}${apiPathServer.postPlaza}`, {
    method: 'POST',
    body: transformObjectDeep({ data: postData }, 'snake'),
  });
  return res;
};

/**
 * 拉取Item详情接口
 */
export const fetchPlazaItemDetail = async (id: string) => {
  const res = await request<CgiResp<IStoryRes>>(`${API_PREFIX}${apiPathServer.plazaItemDetail}`, {
    query: {
      id,
    },
  });
  if (res.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || '信息拉取失败，请稍后重试');
  }
  const turnData = transformObjectDeep(res?.data, 'camel') as IPlazaItemOutput;
  return {
    ...res,
    data: turnData,
  };
};

/**
 * 保存单个Item信息
 */
export const modifyPlazaItemDetail = async (plaza: IPlazaItemInput) => {
  const { materialMap, ...propData }: any = plaza;
  propData.materialMap = postMaterial(propData, materialMap);
  let postData: IPlazaItemOutput = {};
  postData = orgBotData(OrgDataType.input, propData);
  const res = await request(`${API_PREFIX}${apiPathServer.postPlazaItem}`, {
    method: 'POST',
    body: transformObjectDeep({ data: postData }, 'snake'),
  });
  return res;
};

/**
 * 删除配置信息
 */
export const deletePlaza = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.deletePlaza}`, {
    method: 'POST',
    body: { ids: [id] },
  });
  return res;
};

/**
 * copy配置信息
 */
export const copyPlaza = async (id: string) => {
  const res = await request(`${API_PREFIX}${apiPathServer.copyPlaza}`, {
    method: 'POST',
    body: { id },
  });
  return res;
};

/**
 * 更改配置状态
 */
export const changePlazaIsUsed = async (params: {
  id: string;
  isUsed?: boolean;
}) => {
  const res = await request(`${API_PREFIX}${apiPathServer.updatePlazaFields}`, {
    method: 'POST',
    body: transformObjectDeep({ data: params }, 'snake'),
  });
  return res;
};

/**
 * 拉取列表
 * @param id
 * @returns
 */
export const fetchPlazaList = async ({
  page = 1,
  size = 10,
}: {
  page?: number;
  size?: number;
}): Promise<{
  list: IBot[];
  pageInfo: {
    total: number;
    current: number;
    pageSize: number;
  }
}> => {
  const res = await request(`${API_PREFIX}${apiPathServer.plazaList}`, {
    query: {
      page,
      size,
    },
  });
  const { list, pageinfo: pageInfo } = res?.data;
  return {
    list: list?.map((item: any) => transformObjectDeep(item, 'camel')) || [],
    pageInfo: {
      total: pageInfo?.total || 0,
      current: pageInfo?.page || 1,
      pageSize: pageInfo?.size || 10,
    },
  };
};
